import { render } from "./CarLocations.vue?vue&type=template&id=2fbb4bb2"
import script from "./CarLocations.vue?vue&type=script&lang=js"
export * from "./CarLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__